export enum DynWalletGroupingMode {
    ASSET  = 'ASSET',
    WALLET = 'WALLET'
}
